import { Link, createFileRoute } from "@tanstack/react-router";
import { Button } from "@patient-watch/ui/button";
import { Download, Plus } from "lucide-react";
import { toast } from "@patient-watch/ui/sonner";
import { LeadGenNavTabs } from "@/features/lead-gen/components/LeadGenNavTabs";
import { TemplatesTable } from "@/features/lead-gen/components/TemplatesTable";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/templates/")({
    component: LeadTemplatesPage,
});

function LeadTemplatesPage() {
    const { templates, artifacts, setTemplates, exportSql } = useLeadGen();

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Templates", route: { to: "/sales/leads/templates" } },
    ]);

    return (
        <>
            <LeadGenNavTabs
                action={
                    <div className="flex items-center gap-2">
                        <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            className="min-h-0 shrink-0"
                            onClick={() => {
                                exportSql();
                                toast.success("SQL export downloaded");
                            }}
                        >
                            <Download className="h-3.5 w-3.5" />
                            Export SQL
                        </Button>
                        <Button type="button" size="sm" className="min-h-0 shrink-0" asChild>
                            <Link to="/sales/leads/templates/new">
                                <Plus className="h-3.5 w-3.5" />
                                Add template
                            </Link>
                        </Button>
                    </div>
                }
            />

            <TemplatesTable templates={templates} artifacts={artifacts} onTemplatesChange={setTemplates} />
        </>
    );
}
